module.exports = __webpack_public_path__ + "img/5.60b39a05.jpg";